import { SchoolStatus } from '../api';

/** Matches the badge styling already used on the schools list. */
export const STATUS_STYLE: Record<SchoolStatus, string> = {
  ACTIVE: 'bg-green-50 text-green-700 border-green-200',
  SUSPENDED: 'bg-amber-50 text-amber-700 border-amber-200',
  EXPIRED: 'bg-red-50 text-red-700 border-red-200',
};

export const WINDOWS: { label: string; days?: number }[] = [
  { label: 'Last 7 days', days: 7 },
  { label: 'Last 30 days', days: 30 },
  { label: 'Last 90 days', days: 90 },
  { label: 'All time' },
];

/**
 * Licence urgency. The server sends daysToExpiry so this threshold is applied
 * to the same number the totals header counted — the table and the "expiring
 * ≤30d" tile can never disagree.
 */
export function expiryStyle(daysToExpiry: number | null): string {
  if (daysToExpiry === null) return 'text-slate-500';
  if (daysToExpiry < 0) return 'text-red-700 font-medium';
  if (daysToExpiry <= 30) return 'text-amber-700 font-medium';
  return 'text-slate-700';
}

export function expiryLabel(iso: string | null, daysToExpiry: number | null): string {
  if (!iso || daysToExpiry === null) return 'No expiry';
  const date = iso.slice(0, 10);
  if (daysToExpiry < 0) return `${date} (expired)`;
  if (daysToExpiry === 0) return `${date} (today)`;
  if (daysToExpiry <= 30) return `${date} (${daysToExpiry}d left)`;
  return date;
}

/** "Never" / "Today" / "3 days ago" / a date once it stops being interesting. */
export function relativeDay(iso: string | null): string {
  if (!iso) return 'Never';
  const then = new Date(iso).getTime();
  const days = Math.floor((Date.now() - then) / 86_400_000);
  if (days <= 0) return 'Today';
  if (days === 1) return 'Yesterday';
  if (days < 30) return `${days} days ago`;
  return iso.slice(0, 10);
}
